//
//
//
//

export default {
	name: "article-brief",

	props: ['article'],
}
